import { render, staticRenderFns } from "./SimpleInputForm.vue?vue&type=template&id=9619dc48&scoped=true&"
import script from "./SimpleInputForm.vue?vue&type=script&lang=js&"
export * from "./SimpleInputForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleInputForm.vue?vue&type=style&index=0&id=9619dc48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9619dc48",
  null
  
)

export default component.exports